import React from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import './Header.css';


const Header = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar style={{ background: '#58A618' }}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                <Typography variant="h6" component="div">
                                    <img className="headerMobileLogo" alt="" style={{ textAlign: 'center', padding: '2rem', width: '150px' }} src='https://www.tabbank.com/wp-content/uploads/2016/07/tab-bank-logo-white.png' />
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: 'auto' }}>
                                <Typography className="headerMobile" sx={{ fontSize: '16px', padding: '12px', textAlign: 'center' }} component="div">
                                    This service provides data for informed business decisions but should not be solely relied upon.
                                    It does not ensure financing from TAB. The data is dynamic and one of many factors in financing decisions.
                                    TAB Bank does not guarantee the data and is not liable to any party for any reliance on it leading to damages or losses.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    )
}

export default Header;